export default "__VITE_ASSET__B8diyhiO__"